/*
 * @description: CAT 用到的帮助类
 * @author: Mengyu Jin
 * @since: 2019-07-19 11:00:02
 */
import { ASSET_STATE, ASSET_PERMISSION, MERGE_STATE } from "@/views/common/enums";

class CATUtils {
  static assetStateArr = Object.keys(ASSET_STATE);
  static assetPermissionArr = Object.keys(ASSET_PERMISSION);
  static mergeStateArr = Object.keys(MERGE_STATE);
  static getAssetStatus({ state }) {
    switch (state) {
      case ASSET_STATE.uploading:
        return "预处理中";
      case ASSET_STATE.processing:
        return "预处理中";
      // case ASSET_STATE.processed:
      //   return "可用";
      case ASSET_STATE.error:
        return "处理错误";
      case ASSET_STATE.combining:
        return "合并中";
      case ASSET_STATE.combiningError:
        return "合并出错";
      // case ASSET_STATE.combined:
      //   return "可用";
      case ASSET_STATE.canUse:
        return "可用";
    }
  }
  static getTmAssetStatus({ state }) {
    switch (state) {
      case ASSET_STATE.uploading:
        return "预处理中";
      case ASSET_STATE.processing:
        return "预处理中";
      case ASSET_STATE.processed:
        return "可预览待完成";
      case ASSET_STATE.error:
        return "导入出错";
      case ASSET_STATE.combining:
        return "合并中";
      case ASSET_STATE.combiningError:
        return "合并出错";
      case ASSET_STATE.combined:
        return "可预览待完成";
      case ASSET_STATE.canUse:
        return "可用";
    }
  }
  static getAssetPermission({ shareState }) {
    switch (shareState) {
      case ASSET_PERMISSION.private:
        return "仅自己可用";
      case ASSET_PERMISSION.readOnly:
        return "共享但只读";
      case ASSET_PERMISSION.public:
        return "共享且可改";
    }
  }
  static isPreprocessing({ state }) {
    return [ASSET_STATE.uploading, ASSET_STATE.processing].includes(state);
  }

  /**
   * 用户能否进入
   */
  static isEnterable(row) {
    return CATUtils.isTransferable(row);
  }

  /**
   * 用户能否引用
   * @param {*} row
   * @returns
   */
  static isUsable(row) {
    return CATUtils.isTransferable(row);
  }

  /**
   * 记忆库用户能否引用
   * @param {*} row
   * @returns
   */
  static isTmUsable(row) {
    return ASSET_STATE.canUse === row.state;
  }

  static isDealing({ state }) {
    return [ASSET_STATE.uploading,ASSET_STATE.combining,ASSET_STATE.processing].includes(
      state
    );
  }

  static isWaitForUse({ state }) {
    return [ASSET_STATE.processed,ASSET_STATE.combined].includes(
      state
    );
  }

  static isError({ state }) {
    return [ASSET_STATE.error,ASSET_STATE.combiningError].includes(
      state
    );
  }

  /**
   * 用户能否导入/导出
   */

  static isTransferable({ state }) {
    return [ASSET_STATE.processed, ASSET_STATE.combining, ASSET_STATE.combiningError, ASSET_STATE.combined,ASSET_STATE.canUse].includes(
      state
    );
  }

  static _generatorParentProperty(domain) {
    if (!domain || !domain.conditions) return;
    domain.conditions.$$each((condition) => {
      condition.parent = domain;
      this._generatorParentProperty(condition);
    });
  }

  static getCopyStatus(state) {
    switch (state) {
      case MERGE_STATE.notStart:
        return "转换中";
      case MERGE_STATE.processing:
        return "转换中";
      case MERGE_STATE.processed:
        return "转换完成";
      case MERGE_STATE.error:
        return "转换失败";
      case null:
        return "-";
    }
  }

  static isMergePreprocessing(state) {
    return [MERGE_STATE.notStart, MERGE_STATE.processing].includes(state);
  }
  static getMergeStatus(state) {
    if(state === null) return "-";

    switch (state) {
      case MERGE_STATE.notStart:
        return "合并中";
      case MERGE_STATE.processing:
        return "合并中";
      case MERGE_STATE.processed:
        return "已合并";
      case MERGE_STATE.error:
        return "合并出错";
      case MERGE_STATE.canUse:
        return "可用";
      default:
        return "-";
    }
  }
}

export default CATUtils;
